// ---------------------------------------------------------------------------
// CAMPAIGN CONFIGURATION — fill in the placeholders below after build.
// ---------------------------------------------------------------------------

// Registered committee name shown in the "Paid for by" disclaimer (NY requirement).
export const COMMITTEE_NAME = "Ontario County Republican Committee";

// External donation / payment page URL.
export const DONATE_URL = "https://secure.anedot.com/friends-of-jeff-trickler/55780e8f-237f-4df8-ba06-6fd6820af5f5";

// Destination email for contact-form submissions.
export const CONTACT_EMAIL = "FriendsofJeffTrickler@gmail.com";

// Formspree endpoint — contact-form submissions are emailed to CONTACT_EMAIL.
export const FORMSPREE_ENDPOINT = "https://formspree.io/f/mlgqoeby";

// Campaign Facebook page.
export const FACEBOOK_URL = "https://www.facebook.com/share/1BSqKwyueh/?mibextid=wwXIfr";

export const CANDIDATE = {
  name: "Jeffrey Trickler",
  shortName: "Jeff Trickler",
  office: "Ontario County Treasurer",
  subhead: "Candidate for Re-election",
  tagline: "Experienced leadership. Proven results. Accountability for taxpayers.",
};

// Real, campaign-provided imagery.
export const LOGO =
  "https://customer-assets-lqy194kg.emergentagent.net/job_trickler/artifacts/s4mmsyhh_For%20t-shirts.webp";

export const PHOTOS = {
  headshot:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_f71d3863-584d-4452-9a4a-f09c44354945/artifacts/cmk7biya_Trickler_cropped_web_240x300px.png",
  cooking:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_f71d3863-584d-4452-9a4a-f09c44354945/artifacts/3kjz5orv_IMG_2190.webp",
  salads:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_f71d3863-584d-4452-9a4a-f09c44354945/artifacts/dcix4o5s_IMG_2194.webp",
  parade:
    "https://customer-assets-lqy194kg.emergentagent.net/job_trickler/artifacts/rcutslr9_image3.jpeg",
  kids:
    "https://customer-assets-lqy194kg.emergentagent.net/job_trickler/artifacts/l1y63uj9_image4.jpeg",
  team:
    "https://customer-assets-lqy194kg.emergentagent.net/job_trickler/artifacts/3bb15p52_image1.jpeg",
  supporter:
    "https://customer-assets-lqy194kg.emergentagent.net/job_trickler/artifacts/8m4pbhjn_image0.jpeg",
};

// Stock imagery (used only for atmosphere — never for Jeff himself).
export const STOCK = {
  flag:
    "https://images.pexels.com/photos/7483195/pexels-photo-7483195.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  government:
    "https://images.unsplash.com/photo-1667849921481-9e13c239ee3d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwxfHxjbGFzc2ljJTIwZ292ZXJubWVudCUyMGJ1aWxkaW5nJTIwYXJjaGl0ZWN0dXJlJTIwY29sdW1uc3xlbnwwfHx8fDE3ODQ5Mjg4MTN8MA&ixlib=rb-4.1.0&q=85",
};

// Campaign photo wheel. Add more objects here as new photos arrive.
export const CAMPAIGN_PHOTOS = [
  {
    src: PHOTOS.parade,
    alt: "Jeff Trickler marching and waving during a local parade",
    caption: "On the campaign trail — marching in the community parade.",
  },
  {
    src: PHOTOS.kids,
    alt: "Jeff Trickler handing treats to children along a parade route",
    caption: "Connecting with the youngest members of the community.",
  },
  {
    src: PHOTOS.team,
    alt: "Jeff Trickler with the campaign team beneath a Strong Communities, Strong Leaders banner",
    caption: "Standing with the team — Strong Communities, Strong Leaders.",
  },
  {
    src: PHOTOS.supporter,
    alt: "Jeff Trickler with a supporter at a summer campaign event",
    caption: "Meeting supporters across Ontario County.",
  },
  {
    src: PHOTOS.cooking,
    alt: "Jeff Trickler volunteering in a community kitchen",
    caption: "Serving the community — a chicken barbecue fundraiser.",
    position: "center 22%",
  },
  {
    src: PHOTOS.salads,
    alt: "Jeff Trickler preparing meals at a local community event",
    caption: "Local roots — pitching in wherever help is needed.",
    position: "center 12%",
  },
];

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Accomplishments", to: "/accomplishments" },
  { label: "News", to: "/news" },
  { label: "Donate", to: "/donate" },
  { label: "Contact", to: "/contact" },
];
